import {useState, useEffect, useCallback} from 'react';
import {Helmet} from 'react-helmet';
import {
  Card,
  Paper,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Button,
  Chip,
} from '@material-ui/core';
import {Add as AddIcon} from '@material-ui/icons';
import {useWindowResize} from '@ozgene/gp5.hooks.use-window-resize';
import {
  findConsumables,
  findMetricUnits,
} from 'Consumables/service/ConsumableService';
import ConsumableList from 'Consumables/components/ConsumableList';
import MetricUnitList from 'Consumables/components/MetricUnitList';
import UpdateCreateConsumableDialog from 'Consumables/views/UpdateCreateConsumableDialog';
import UpdateCreateMetricUnitDialog from 'Consumables/views/UpdateCreateMetricUnitDialog';

export default function ConsumableLobby(props) {
  const {height} = useWindowResize();
  const [isLoading, setIsLoading] = useState(true);
  const [consumables, setConsumables] = useState([]);
  const [metricUnits, setMetricUnits] = useState([]);
  const [consumableDialogOpen, setConsumableDialogOpen] = useState(false);
  const [metricUnitDialogOpen, setMetricUnitDialogOpen] = useState(false);
  const [selectedConsumable, setSelectedConsumable] = useState(null);
  const [selectedMetricUnit, setSelectedMetricUnit] = useState(null);
  const handleOpenConsumableDialog = () => setConsumableDialogOpen(true);
  const handleCloseConsumableDialog = () => {
    setSelectedConsumable(null);
    setConsumableDialogOpen(false);
    handleRetrieveConsumables();
  };
  const handleEditConsumable = (consumable) => {
    setSelectedConsumable(consumable);
    setConsumableDialogOpen(true);
  };
  const handleOpenMetricUnitDialog = () => setMetricUnitDialogOpen(true);
  const handleCloseMetricUnitDialog = () => {
    setSelectedMetricUnit(null);
    setMetricUnitDialogOpen(false);
    handleRetrieveMetricUnits();
  };
  const handleEditMetricUnit = (metricUnit) => {
    setSelectedMetricUnit(metricUnit);
    setMetricUnitDialogOpen(true);
  };
  const handleCreateConsumable = () => {
    setSelectedConsumable(null);
    handleOpenConsumableDialog();
  };
  const handleCreateMetricUnit = () => {
    setSelectedMetricUnit(null);
    handleOpenMetricUnitDialog();
  };
  const handleRetrieveConsumables = useCallback(async () => {
    const newConsumables = await findConsumables();

    setConsumables(newConsumables);
  }, []);
  const handleRetrieveMetricUnits = useCallback(async () => {
    const newMetricUnits = await findMetricUnits();

    setMetricUnits(newMetricUnits);
  }, []);

  useEffect(() => {
    if (isLoading) {
      handleRetrieveConsumables();
      handleRetrieveMetricUnits();

      setIsLoading(false);
    }
  }, [handleRetrieveConsumables, handleRetrieveMetricUnits, isLoading]);

  return (
    !isLoading && (
      <>
        <Helmet title="Consumables & Units" defer={false} />

        <Paper style={{maxHeight: height - 64}}>
          <Grid style={{padding: 20}} container spacing={2}>
            <Grid item xs={6}>
              <Card raised style={{maxHeight: height - 110}}>
                <CardHeader
                  title="Consumables"
                  titleTypographyProps={{variant: 'h5'}}
                  avatar={
                    <Chip variant="outlined" label={consumables.length} />
                  }
                  action={[
                    <Button
                      key={1}
                      style={{marginTop: 7, marginRight: 7}}
                      variant="outlined"
                      color="primary"
                      startIcon={<AddIcon />}
                      onClick={handleCreateConsumable}
                    >
                      Add Consumable
                    </Button>,
                  ]}
                />
                <Divider />
                <CardContent>
                  <ConsumableList
                    consumables={consumables}
                    onEditConsumable={handleEditConsumable}
                  />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card raised style={{maxHeight: height - 110}}>
                <CardHeader
                  title="Metric Units"
                  titleTypographyProps={{variant: 'h5'}}
                  avatar={
                    <Chip variant="outlined" label={metricUnits.length} />
                  }
                  action={[
                    <Button
                      key={1}
                      style={{marginTop: 7, marginRight: 7}}
                      variant="outlined"
                      color="primary"
                      startIcon={<AddIcon />}
                      onClick={handleCreateMetricUnit}
                    >
                      Add Metric Unit
                    </Button>,
                  ]}
                />
                <Divider />
                <CardContent>
                  <MetricUnitList
                    metricUnits={metricUnits}
                    onEditMetricUnit={handleEditMetricUnit}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Paper>
        {consumableDialogOpen && (
          <UpdateCreateConsumableDialog
            closeDialog={handleCloseConsumableDialog}
            entity={selectedConsumable}
          />
        )}
        {metricUnitDialogOpen && (
          <UpdateCreateMetricUnitDialog
            closeDialog={handleCloseMetricUnitDialog}
            entity={selectedMetricUnit}
          />
        )}
      </>
    )
  );
}
